{
  "header": "Senaste anslag",
  "impersonate": {
    "text": "Kenno-användare {{impersonator}}"
  },
  "buttons": {
    "moreBulletins": "Fler anslag",
    "readBulletin": "Läs anslag"
  },
  "pendingOperations": {
    "description": "Du påbörjade en åtgärd men återvände inte till boendesidorna från autentiseringen. Slutför åtgärden genom att bekräfta den eller förkasta den.",
    "identificationRequired": "Att bekräfta åtgärden kräver stark autentisering. Autentisera dig för att kunna bekräfta åtgärden.",
    "terminationTitle": "Ofullständig uppsägningsanmälan",
    "modificationTitle": "Ofullständig avtalsändring",
    "continue": "Fortsätt bekräftelsen",
    "identify": "Autentisera",
    "reject": "Förkasta",
    "error": "Det gick inte att hämta obekräftade åtgärder. Försök igen senare.",
    "rejectError": "Det gick inte att förkasta åtgärden. Försök igen senare."
  }
}
